/**
 * Estados del mueble, iguales a las constantes de Furniture.
 *
 * Entre Asignado y Libre se mueve solo, según entre o salga de un control. A
 * mano solo tiene sentido marcarlo Dado de baja, y el backend lo rechaza si el
 * mueble todavía está colocado en un cliente.
 */
export const ESTADOS_MUEBLE = [
  { id: 'A', descripcion: 'Asignado' },
  { id: 'B', descripcion: 'Dado de baja' },
  { id: 'F', descripcion: 'Libre' }
];

/** Nombre del estado. Si llega uno que no conocemos se muestra el código crudo. */
export const nombreEstadoMueble = (id) =>
  ESTADOS_MUEBLE.find((e) => e.id === id)?.descripcion || id || '';
